function stars(rating) {
    var rating = Math.min(Math.max(rating, 0.0), 5.0);
    //rating = (rating - 3).toFixed(1); //Just for testing
    var ratingParts = rating.toString().split('.');
    var firstPart = parseInt(ratingParts[0], 10);
    var lastPart = parseInt(ratingParts[1], 10);
    var ratingCssClass = '';

    if(isNaN(lastPart) || lastPart < 5) {
        ratingCssClass = firstPart;
    }
    else if(lastPart > 5) {
        ratingCssClass = (firstPart + 1);
    }
    else if(lastPart === 5) {
        ratingCssClass = firstPart + '-5';
    }

    return '<span class="Rating-'+ratingCssClass+'">'+rating+'</span>';
};

$(document).ready(function() {
    $('.tes-breadcrumbs li.breadcrumb').on('click', 'label', function() { window.location.href = $(this).next('a').attr('href'); });
    $('.tes-filterList form.filter-list-form input.submit').remove();
    $('.tes-filterList form.filter-list-form').on('click', 'input.checkbox', function() { $(this).closest('form.filter-list-form').submit(); });
    $('.tes-filterList li.filter.more').hide();
    $('.tes-filterList').on('click', 'li.more-link a', function() {
        $(this).closest('ol.filter-list').find('li.filter.more').toggle();
    });
    //$('img.tes-preview').each(function() {
    //    $(this).attr('src', 'http://tes.thumbnails-transitional.s3.amazonaws.com/' + images[crc32ish($(this).data('id')) % images.length]);
    //});
    $('.field.ratingaverage').each(function() {
        var rating = parseFloat($(this).text());
        $(this).html(stars(rating));
    });

    //Pagination fix
    $('.pagination.tk-stl-pagination-arrows .active').wrapInner('<span/>');

});